var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.902,
    height: 25.358,
    viewBox: "0 0 25.902 25.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#208ce1;stroke-width:1.5px;}.a{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-678.404 -317.483)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M690.457,397.388H681.25a2.1,2.1,0,0,1-2.1-2.1V381.1a2.1,2.1,0,0,1,2.1-2.1h16.718a2.1,2.1,0,0,1,2.1,2.1v6.077",
    transform: "translate(0 -58.835)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 5.724,
    transform: "translate(684.109 317.483)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 5.724,
    transform: "translate(695.586 317.483)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 20.91,
    transform: "translate(679.154 326.685)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 5.738,
    transform: "translate(682.544 330.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H2.769",
    transform: "translate(682.544 334.684)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.964,
    cy: 5.964,
    r: 5.964,
    transform: "translate(691.626 330.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1097.273,691.553v3.684h3.111",
    transform: "translate(-399.899 -358.597)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.527ce2d500de89d762fca5085aa1a5a1.svg";
export { ForwardRef as ReactComponent };